const SHEET_CHANGES_LINEAGE_SELECTOR = ".sheet-changes-lineage__timeline";

/**
 * Opens the horizontal version history at its newest item. Keeping this in the
 * bundled frontend avoids inline scripts in the shared PHP partial.
 */
export function initSheetChangesLineage(root = document) {
  if (!(root instanceof Document || root instanceof Element)) {
    return;
  }

  const timelines =
    root instanceof Element && root.matches(SHEET_CHANGES_LINEAGE_SELECTOR)
      ? [root]
      : Array.from(root.querySelectorAll(SHEET_CHANGES_LINEAGE_SELECTOR));

  timelines.forEach((timeline) => {
    if (!(timeline instanceof HTMLElement) || timeline.dataset.lineageScrollInitialized === "1") {
      return;
    }

    timeline.dataset.lineageScrollInitialized = "1";
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        timeline.scrollLeft = Math.max(0, timeline.scrollWidth - timeline.clientWidth);
      });
    });
  });
}
